import { IColumns } from '../../../../../components/Dashboard/TableSmall'

export interface IData {
  columns: IColumns[]
}

export const data: IData = {
  columns: [
    {
      id: 'underlier',
      label: 'SYMBOL',
      format: (value) => `${value.slice(0, -3)}/${value.slice(-3)}`,
    },
    {
      id: 'bid',
      label: 'BID',
      format: (value) => value || '–',
    },
    {
      id: 'ask',
      label: 'ASK',
      format: (value) => value || '–',
    },
  ],
}
